import apiMenu from '@/api/menu'
import * as types from './mutation_types'
import detector from '@/services/device-detector'
import { cloneDeep } from 'lodash'
import Cookies from 'js-cookie'

export default {
  // TODO: переименовать
  getAndSetMenuGoals: async ({ commit, dispatch, rootGetters }, options = {}) => {
    commit(types.IS_LOADING)

    let ret = null

    try {
      const { goals, hash } = await dispatch('getMenuGoals', options)
      commit(types.SET_GOALS_HASH, hash)

      // check current target
      dispatch('vcp/checkCurrentTarget', null, { root: true })
      // /check current target

      ret = goals
    } catch (error) {
      ret = error
    } finally {
      commit(types.IS_LOADING)
    }

    return ret
  },
  getMenuGoals: async ({ commit, rootGetters, getters, dispatch, rootState }, options = {}) => {
    let daysFilterTemplateId
    if (!rootGetters['client/isLoggedIn']) {
      daysFilterTemplateId = options?.daysFilterTemplateId || undefined
      if (daysFilterTemplateId === undefined) {
        // daysFilterTemplateId = rootGetters['client/isLoggedIn'] ? undefined : rootGetters['templates/daysFilterTemplateId']
        daysFilterTemplateId = rootGetters['templates/daysFilterTemplateId'] || undefined
      }
    }
    if (!rootGetters['city/getActive']) {
      await dispatch('city/getCities', {}, { root: true })
    }
    const cityId = options.cityId || rootGetters['city/getActive']?.id || 1
    const bftucid = options.bftucid || Cookies.get('bftucid')
    const goalsData = {
      dimensions: {
        cityId: cityId,
        brandId_H: 'lY',
        isSmartphone: detector.isSmartphone,
        isAntiFbVersion: rootGetters['marketing/specificQueryParams'].ffb || false,
        globalPlacement: 'landing',
        cmz_H: rootGetters['marketing/specificQueryParams']?.cmz || null,
        gfv3: true,
        // ab: payload.ab,
      },
      bftucid,
      daysFilterTemplateId,
      isLongation: false,
      // forSubscription: rootGetters['enabledBusinessProduct'] === 'subscription'
      // family: false,
      // firstDeliveryDate: 'string',
      // session: 'morning'
    }

    if (rootGetters['vcp/currentTarget'] === 'p1' && rootState.order.isBmiOrder) {
      goalsData.useClientsBmi = true
      goalsData.dimensions.menuTypeGroupId = 1
    }

    if (rootGetters['vcp/currentTarget'] === 'p1' && rootGetters['client/unauthorizedImtData']?.purposeWeight) {
      goalsData.clientParams = {
        height: rootGetters['client/unauthorizedImtData'].height,
        weight: rootGetters['client/unauthorizedImtData'].weight,
        purposeWeight: rootGetters['client/unauthorizedImtData'].purposeWeight,
        gender: rootGetters['client/unauthorizedImtData'].gender,
        birthday: rootGetters['client/unauthorizedImtData'].birthday,
        lifestyleId_H: rootGetters['client/unauthorizedImtData'].lifestyleId_H,
      }
    }

    if (options.useClientsBmi) {
      goalsData.useClientsBmi = options.useClientsBmi
      goalsData.dimensions.menuTypeGroupId = 1
    }

    let ret = null

    try {
      const { filter = { meals: null, days: null } } = rootGetters['client/profile'].menuCalendarConfig || { filter: { meals: null, days: null } }
      const newHash = JSON.stringify({ ...goalsData, isLoggedIn: rootGetters['client/isLoggedIn'], filter })
      if (options.hardUpdate || newHash !== getters.goalsHash) {
        const menuTypeGroupIds = [1, 2, 3, 5]
        const goalsRequests = []
        for (const menuTypeGroupId of menuTypeGroupIds) {
          const payload = cloneDeep(goalsData)
          payload.dimensions.menuTypeGroupId = menuTypeGroupId
          if (payload.useClientsBmi && menuTypeGroupId !== 1) {
            delete payload.useClientsBmi
          }
          goalsRequests.push(apiMenu.getMenuGoals(payload))
        }
        const goalsResponses = await Promise.all(goalsRequests)
        const goalsFromAllResponses = [
          ...goalsResponses[0]?.data?.goals,
          ...goalsResponses[1]?.data?.goals,
          ...goalsResponses[2]?.data?.goals,
          ...goalsResponses[3]?.data?.goals,
        ]

        commit(types.SET_GOALS, goalsFromAllResponses)
        ret = { goals: goalsFromAllResponses, hash: newHash }
      } else {
        ret = { goals: getters.goals, hash: getters.goalsHash }
      }
    } catch (error) {
      ret = error
    }

    return ret
  },
  setMenuGoals: async ({ commit, rootGetters }, goals = {}) => {
    commit(types.SET_GOALS, goals)
  },
}
